module.exports = __webpack_public_path__ + "img/canbadge-round-44mm-asa_trimmark.c6525a71.png";